/* eslint-disable react-hooks/exhaustive-deps */
import {
  FunctionComponent as F,
  useEffect,
  useState } from 'react';
import { useParams } from 'react-router-dom';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputAdornment from '@mui/material/InputAdornment';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { validatePrice } from '../../utils/validate';
import { updateBudgetAsync } from '../../core/store/protocol/protocol.thunks';
import { useAppDispatch } from '../../core/store/hooks';
import HelpIcon from '@mui/icons-material/Help';
import { Stack } from '@mui/material';
import TextTooltip from '../UI/Tooltip/TextTooltip';
import { IState } from '../../core/store/store';
import { useSelector } from 'react-redux';



interface Params
{
  protocolId?: string
}

const Budget: F = () =>
{
  const appDispatch = useAppDispatch();
  const params = useParams() as Params;

  const budget = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === Number(params.protocolId))?.budget);
  const currencySymbol = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === Number(params.protocolId))?.currencySymbol);
  const protocolEdit = useSelector((state: IState) => state.protocol.protocols
    .find(p => p.protocolId === Number(params.protocolId))?.edit);

  const edit = protocolEdit === undefined || protocolEdit;

  const [currentBudget, setCurrentBudget] = useState<string>((budget || 0).toFixed(2));
  useEffect(() =>
  {
    setCurrentBudget((budget || 0).toFixed(2));
  }, [budget]);

  const handleBudgetBlur = () =>
  {
    if(!validatePrice(currentBudget) || Number(currentBudget) === budget)
    {
      setCurrentBudget((budget || 0).toFixed(2));
      return;
    }

    setCurrentBudget(Number(currentBudget).toFixed(2));
    appDispatch(updateBudgetAsync(Number(currentBudget), Number(params.protocolId)));
  };

  const labelWithHelp = (
    <Stack direction="row">
      {"Monthly Budget"}
      <TextTooltip tooltipPlacement={"top"} lines={[
        "Enter your budget here",
        "(highest priority supplements within budget shown in green)."]}>
        <HelpIcon
          cursor="pointer"
          fontSize='small'
          sx={{ height: 17, color: 'lightGray', cursor: 'pointer', pt: 0.5, pl: 0.3 }}
          onClick={() => {}}/>
      </TextTooltip>
    </Stack>);

  return (
    <FormControl>
      <InputLabel htmlFor='outlined-adornment-amount'>
        {labelWithHelp}
      </InputLabel>
      <OutlinedInput
        size='small'
        sx={{ pt: '6px' }}
        inputProps={{ style: { fontWeight: 'bold', textAlign: 'right' } }}
        startAdornment={<InputAdornment position='start'>{currencySymbol}</InputAdornment>}
        id='Budget'
        label={labelWithHelp}
        value={currentBudget !== null ? currentBudget : ''}
        disabled={!edit}
        onChange={event => setCurrentBudget(event.target.value)}
        onBlur={handleBudgetBlur}
        error={!validatePrice(currentBudget)}/>
    </FormControl>);
};

export default Budget;
